import { LocalProfile } from "@core/model/local-profile";
import { PROFILE } from "@core/utility/settings";
import StorageService from "@shared/services/storage.service";
import SimpleHeader from "@shared/ui/navigation/simple-header/simple-header";
import { FaUserCircle } from "react-icons/fa";
import { RiShutDownLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

import { appFeature } from "../../../app.feature";

const getLocalProfileFromStorage = () => {
  const profile = StorageService.load<LocalProfile>(PROFILE);
  return profile || null;
};

export function useAuthCustomerNavigation(logo: string, company: string) {
  const navigate = useNavigate();
  const profile = getLocalProfileFromStorage();

  const handleLogout = () => {
    navigate("/login");
  };
  const headerElement = (
    <SimpleHeader
      title={company}
      logo={logo}
      style={{ header: appFeature.theme.header }}
    >
      <section className="flex gap-2 items-center p-2 rounded-lg cursor-pointer border border-transparent hover:border-gray-50 hover:bg-white">
        <span className="text-2xl">
          <FaUserCircle />
        </span>
        <div className="flex flex-col">
          <span className="text-base font-bold">
            {profile?.name || "System"}
          </span>
          <span className="text-xs">{profile?.roleName || "Admin"}</span>
        </div>
      </section>

      <section className="inline-flex">
        <button
          className="flex gap-2 items-center hover:bg-gray-50 hover:bg-opacity-40 p-2 rounded-lg border border-gray-600"
          onClick={() => handleLogout()}
        >
          <span className="text-2xl">
            <RiShutDownLine />
          </span>
        </button>
      </section>
    </SimpleHeader>
  );

  return {
    headerElement,
  };
}
